import { getImage } from 'gatsby-plugin-image';
import mixpanel from 'mixpanel-browser';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { propTypesIllustration } from '../../constants/Proptypes.js';

import Button, { ButtonAppearance } from '../../../ui/Atoms/Button';
import Input from '../../../ui/Atoms/Input';
import Picture from '../../../ui/Atoms/Picture';

import { getStaticUrl } from '../../utils/getStaticUrl.js';
import { gtm } from '../../utils/gtm.js';

import * as S from './EventBanner.styles.js';

export const EventBanner = ({
  content: {
    bannerJoinEventDatatrack,
    bannerJoinEventButtonLabel,
    bannerJoinEventIllustration,
    bannerJoinEventLabel,
    bannerJoinEventPlaceholder,
  },
  is404,
  slug,
}) => {
  const [code, setCode] = useState(slug || '');
  const { alt, localFile } = bannerJoinEventIllustration || '';

  const imageProps = {
    imageObject: getImage(localFile),
    imageUrl: getStaticUrl(localFile?.publicURL),
  };

  const format = /[ ` !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  const hasSpecialChar = format.test(code);
  const origin = is404 ? '404' : 'banner';

  const joinEvent = event => {
    event.preventDefault();

    if (code.length >= 1) {
      mixpanel.track('Attend an event', {
        Slug: code.toUpperCase(),
      });

      if (bannerJoinEventDatatrack) {
        gtm({
          event: bannerJoinEventDatatrack,
          // eslint-disable-next-line camelcase
          event_category: 'Button',
          event_label: bannerJoinEventDatatrack,
          essential: true,
        });
      }
      window.location.href = `https://app.wooclap.com/${code}?from=${origin}`;
    }
  };

  return (
    <S.Wrapper>
      <S.Banner is404={is404}>
        {imageProps.imageUrl && (
          <S.IllustrationWrapper>
            <Picture altText={alt} {...imageProps} />
          </S.IllustrationWrapper>
        )}
        {bannerJoinEventLabel && (
          <S.BannerLabel>{bannerJoinEventLabel}</S.BannerLabel>
        )}
        <S.ActionWrapper is404={is404} id='event-banner' onSubmit={joinEvent}>
          <Input
            hasError={hasSpecialChar}
            hasFocus={false}
            onChange={ev => setCode(ev.target.value)}
            placeholder={bannerJoinEventPlaceholder}
            value={code.toUpperCase()}
          />
          <Button
            form='event-banner'
            appearance={ButtonAppearance.CIRCULAR}
            dataTrackAttribute={bannerJoinEventDatatrack}
            onClick={joinEvent}
          >
            {bannerJoinEventButtonLabel}
          </Button>
        </S.ActionWrapper>
      </S.Banner>
    </S.Wrapper>
  );
};

EventBanner.propTypes = {
  /**
   * Content of the banner.
   */
  content: PropTypes.shape({
    bannerJoinEventButtonLabel: PropTypes.string,
    bannerJoinEventDatatrack: PropTypes.string,
    bannerJoinEventIllustration: PropTypes.shape(propTypesIllustration),
    bannerJoinEventLabel: PropTypes.string,
    bannerJoinEventPlaceholder: PropTypes.string,
  }),
  /**
   * Display a 404 page design.
   */
  is404: PropTypes.bool,
  /**
   * Event slug used to prefill the input.
   */
  slug: PropTypes.string,
};
